<div class="row div-spacer">
    <div class="col-sm-7">
            <h2>Worksheets</h2>
            <p>Generate and print out worksheets for offline on paper practice.
            Give children chance to master writing skills and question answering steps.
            Capture the answers into the system after completion</p>
        </div>
    <div class="col-sm-5 text-center">
        <img src="/assets/images/landing-page/worksheet.png" width="200">
        </div>


    </div>
